import { useQuery } from '@tanstack/react-query';

import {
  getClaimReportCardsApi,
  getTicketsReportLastMonthApi,
  postTicketsReportScheduleApi,
} from 'api/reports';
import {
  GetClaimReportParamsDTO,
  GetClaimReportsResponseDTO,
  GetTicketsReportLastMonthParamsDTO,
  GetTicketsReportLastMonthResponseDTO,
  GetTicketsReportScheduleParamsDTO,
  GetTicketsReportScheduleResponseDTO,
} from 'declarations/dto/reports';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchTicketsReportLastMonth = (params: GetTicketsReportLastMonthParamsDTO) =>
  useQuery<GetTicketsReportLastMonthResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchTicketsReportLastMonth, params],
    () => getTicketsReportLastMonthApi(params),
    { staleTime: RequestStaleTimeE.TicketsReportLastMonth }
  );

export const useFetchClaimReports = (params: GetClaimReportParamsDTO) =>
  useQuery<GetClaimReportsResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchClaimReportCards, params],
    () => getClaimReportCardsApi(params),
    { staleTime: RequestStaleTimeE.ClaimReportCards }
  );

export const useFetchScheduleReports = (params: GetTicketsReportScheduleParamsDTO) =>
  useQuery<GetTicketsReportScheduleResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchClaimReportCards, params],
    () => postTicketsReportScheduleApi(params),
    { staleTime: RequestStaleTimeE.ClaimReportCards }
  );
